import { render, staticRenderFns } from "./OfflineEmployee.vue?vue&type=template&id=2d244b58&scoped=true&"
import script from "./OfflineEmployee.vue?vue&type=script&lang=js&"
export * from "./OfflineEmployee.vue?vue&type=script&lang=js&"
import style0 from "./OfflineEmployee.vue?vue&type=style&index=0&id=2d244b58&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d244b58",
  null
  
)

export default component.exports